<template>
    <vuescroll ref="vs">
    <div class="max-w-content">
        <article class="main-article" id="art">
            <div class="article-header">
                <post-date :post="post"></post-date>
                <h1>{{post.title}}</h1>
                <favorite-switcher v-show="!post.isRevision" :active="post.inFavorites" :loading="loadingFavorite" @click="setFavorite"></favorite-switcher>
                <span class="js-hide-leaving-component" title="Закрыть" @click="closeActivePost">
                    <icon-base width="16" height="16" viewBox="0 0 16 16"><icon-arrow-close/></icon-base>
                </span>
            </div>
            <tag-list :tags="getPostTags(post.tags)" :active-tags="activeTags" @click="tagClick($event)"></tag-list>
            <div v-html="post.content"></div>
            <tag-list :tags="getPostTags(post.tags)" :active-tags="activeTags" @click="tagClick($event)" class="large-indent"></tag-list>
        </article>
        <related-posts :posts="relatedPosts"></related-posts>
        <hr/>
        <div class="comments-box">
            <p class="box-title">Комментарии</p>
            <div class="single-comment-form" v-show="!post.isRevision">
                <comment-form :parent="0" :cancel-btn="false" :action="SEND_COMMENT"></comment-form>
            </div>
            <post-comments :comments="comments"></post-comments>
            <div class="accordion comments-view">
                <old-post-comments v-for="(group, index) in oldComments" :key="index" :commentsGroup="group"></old-post-comments>
            </div>
        </div>
        <span title="Наверх" class="js-scroll-to-top" @click="handleScrollTop">
            <span>
                <icon-base width="16" height="16" viewBox="0 0 16 16"><icon-arrow-up/></icon-base>
				Наверх
			</span>
        </span>
    </div>

    </vuescroll>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex'
    import TagList from "../common/TagList"
    import RelatedPosts from "./RelatedPosts"
    import PostComments from "./PostComments";
    import PostDate from "./PostDate";
    import vuescroll from 'vuescroll';
    import CommentForm from "./CommentForm";
    import IconBase from "../common/IconBase";
    import IconArrowClose from "../common/icons/IconArrowClose";
    import IconArrowUp from "../common/icons/IconArrowUp";
    import OldPostComments from "./OldPostComments";
    import {SEND_COMMENT} from "../../constants/common";
    import FavoriteSwitcher from "../common/FavoriteSwitcher";
    import 'lightgallery.js'

    export default {
        name: 'active-post',
        components: {
            FavoriteSwitcher,
            OldPostComments,
            IconBase,
            IconArrowClose,
            IconArrowUp,
            CommentForm,
            PostDate,
            PostComments,
            TagList,
            RelatedPosts,
            vuescroll
        },
        props: {
            post : {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        data() {
            return {
                SEND_COMMENT: SEND_COMMENT,
                loadingFavorite: false,
                isMobile: false
            };
        },
        computed: {
            ...mapState({
                tags: state => state.knowledge.tags,
                posts: state => state.knowledge.posts,
                relatedPosts: state => state.knowledge.relatedPosts,
                comments: state => state.knowledge.postComments,
                oldComments: state => state.knowledge.oldPostComments,
                activeTags: state => state.knowledge.activeTags,
            }),
            ...mapGetters('knowledge', [
                'getPostTags',
            ]),
        },
        created() {
            //this.getPostComments();
        },
        methods: {
            ...mapActions('knowledge', [
                'getPostComments',
                'closeActivePost',
                'getPostsAfterTagClick',
                'setFavoritePost'
            ]),
            handleScrollTop () {
                this.$refs['vs'].scrollTo(
                    {
                        y: '0%'
                    },
                    1000
                );
            },
            setFavorite() {
                if (!this.loadingFavorite) {
                    this.loadingFavorite = true;
                    this.setFavoritePost(!this.post.inFavorites).then(() => {
                        this.loadingFavorite = false;
                    })
                }
            },
            tagClick(id) {
                if(this.isMobile) {
                    this.closeActivePost();
                }
                this.getPostsAfterTagClick(id);
            }
        },
        watch: {
            post: function(oldPost, newPost) {
                if (oldPost.id !== newPost.id) {
                    this.$refs['vs'].scrollTo(
                        {
                            y: '0%'
                        },
                        200
                    );
                }
            },
        },
        updated() {
            //console.log('updated');
            //console.log(document.getElementById('photo-gallery'));
            this.$nextTick(function() {
                lightGallery(document.getElementById('photo-gallery'), {
                    selector: '.item a',
                    hash: false
                });
            })
        },
        mounted()
        {
            this.isMobile = document.body.clientWidth <= 780;
        }
    }
</script>


<style scoped>
    .single-comment-form {
        padding-bottom: 13px;
        margin-bottom: 32px;
    }
</style>
